export default {
  dashboard: {
    icon: require("@/assets/i/white/icon-dashboard.svg"),
    iconHover: require("@/assets/i/gray/icon-dashboard.svg"),
    titleEs: "Dashboard",
    titleEn: "Dashboard",
    to: "/brand/dashboard"
  },
  // provider: {
  //   icon: require("@/assets/i/white/provider-q-w.svg"),
  //   iconHover: require("@/assets/i/gray/provider-q.svg"),
  //   titleEs: "Calidad de proveedores",
  //   titleEn: "Provider quality",
  //   to: "/brand/providers"
  // }
};
